export default __webpack_public_path__ + "static/media/app-suggestion.39156e1e.svg";